import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=7486d7c1"
import script from "./SignupForm.js?vue&type=script&lang=js&external"
export * from "./SignupForm.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports